// extracted by mini-css-extract-plugin
module.exports = {"links":"_1yyW7J_","linksItem":"WZyJutN"};